module.exports = __webpack_public_path__ + "static/media/Lien_he.351d3a4b.png";